import { GridColumn } from 'types/grid';
import { ModalListData } from 'types/modal';
import { Status } from 'types/status';

//결제대기 중 스케쥴 리스트
export const unPaidScheduleGrid: GridColumn[] = [
  { title: 'ID', key: 'id', width: 100 },
  { title: 'MemberId', key: 'memberId', width: 100 },
  { title: 'Name', key: 'name', width: 180 },
  { title: 'Email', key: 'email', width: 180 },
  { title: 'StartTime', key: 'startTime', width: 240 },
  { title: 'EndTime', key: 'endTime', width: 240 },
  { title: 'Direction', key: 'direction', width: 120 },
  { title: 'Band', key: 'band', width: 120 },
  { title: 'Status', key: 'status', width: 160 },
  { title: 'Payment', key: 'isPayment', width: 160 },
];
//결제완료 스케쥴 리스트
export const paidScheduleGrid: GridColumn[] = [
  { title: 'ID', key: 'id', width: 50 },
  { title: 'Name', key: 'name', width: 120 },
  { title: 'Email', key: 'email', width: 150 },
  { title: 'StartTime', key: 'startTime', width: 140 },
  { title: 'EndTime', key: 'endTime', width: 140},
  { title: 'Direction', key: 'direction', width: 100 },
  { title: 'Band', key: 'band', width: 80 },
  { title: 'Status', key: 'status', width: 100 },
  { title: 'Link Status', key: 'isSendMailS3', width: 90 },
  { title: 'S3 Link', key: 's3Link', width: 600 },
];

// S3 관리 페이지에서 사용하는 Status 배지 정의 (ManageSchedule과 동일)
export const s3Status: Record<string, Status> = {
  IDLE:        { title: 'Idle',      className: 'bg-white border-black text-black' },
  COMPLETED:   { title: 'Done',      className: 'bg-[#DBF8E3] border-[#028E08] text-[#05870A]' },
  SCHEDULED:   { title: 'Scheduled', className: 'bg-[#E6F2FE] border-[#0890F3] text-[#0890F3]' },
  IN_PROGRESS: { title: 'In Progress', className: 'bg-[#E6FEED] border-[#27B72D] text-[#27B72D]' },
  CANCELLED:   { title: 'Cancel',    className: 'bg-white border-[#8F8F8F] text-[#8F8F8F]' },
  CANCEL:      { title: 'Cancel',    className: 'bg-white border-[#8F8F8F] text-[#8F8F8F]' },
  FAILED:      { title: 'Fail',      className: 'bg-[#FEE6E6] border-[#F30808] text-[#F30808]' },
  UNKNOWN:     { title: 'Unknown',   className: 'bg-white border-[#8F8F8F] text-[#8F8F8F]' },
  PROCESS:     { title: 'Process',   className: 'bg-[#E6FEED] border-[#27B72D] text-[#27B72D]' },
  COMPLETE:    { title: 'Done',      className: 'bg-[#DBF8E3] border-[#028E08] text-[#05870A]' },
  FAIL:        { title: 'Fail',      className: 'bg-[#FEE6E6] border-[#F30808] text-[#F30808]' },
};



// Link Send Status 배지 정의
export const s3LinkStatus: Record<string, Status> = {
  true: { title: 'Sent', className: 'bg-[#E6FEED] border-[#27B72D] text-[#27B72D]' },
  false: { title: 'Not Sent', className: 'bg-[#FEE6E6] border-[#F30808] text-[#F30808]' },
};


